const state = {
  showcase: [],
  showcase_id: [],
  showcase_availability: [],
};

export default state;
